import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGift, FiSmartphone, FiBook, FiCalculator } = FiIcons;

const BonusSection = () => {
  const bonuses = [
    {
      title: "FREE AI Apps",
      description: "Lead capture automation tools & Follow-up WhatsApp automation apps",
      icon: FiSmartphone,
      worth: "₹9,999",
      color: "from-blue-500 to-cyan-500"
    },
    {
      title: "Exponential Growth Workbook (PDF)",
      description: "All 4 checklists simplified, Action sheets & scorecards, Revenue leak calculators",
      icon: FiBook,
      worth: "₹7,999",
      color: "from-purple-500 to-pink-500"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Register <span className="text-green-400">FREE</span> & Get These Bonuses Instantly
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {bonuses.map((bonus, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="bg-gradient-to-br from-gray-700/50 to-gray-800/50 border border-yellow-400/30 rounded-2xl p-8 backdrop-blur-sm hover:scale-105 transition-all duration-300"
              >
                <div className="text-center">
                  <div className={`bg-gradient-to-r ${bonus.color} w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6`}>
                    <SafeIcon icon={FiGift} className="text-white text-3xl" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-4">
                    🎁 {bonus.title}
                  </h3>
                  
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    {bonus.description}
                  </p>
                  
                  <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-3 rounded-lg font-bold text-lg">
                    💰 Worth {bonus.worth}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BonusSection;